import { useCallback } from 'react';
import { Action } from '../types';
import { useAppDispatch } from '../stores/redux.store';

export const openAwsCaptchaModal = (): Action => ({
  type: 'OPEN_AWS_CAPTCHA_MODAL',
});

export const closeAwsCaptchaModal = (): Action => ({
  type: 'CLOSE_AWS_CAPTCHA_MODAL',
});

export const awsCaptchaPuzzleCompleted = (): Action => ({
  type: 'AWS_CAPTCHA_PUZZLE_COMPLETED',
});

export const useOpenAwsCaptchaModalFunction = () => {
  const dispatch = useAppDispatch();
  return useCallback(() => {
    dispatch(openAwsCaptchaModal());
  }, [dispatch]);
};
